import { useQuery } from '@tanstack/react-query';
import { axiosInt } from 'library';

import { NOTIFICATIONS_KEY, NOTIFICATIONS_URL } from './notificationsConstants';
import useNotificationOrgId from './useNotificationOrgId';

const UNREAD_COUNT_POLLING_MS = 15_000;

export const fetchUnreadCountApi = async (): Promise<{ count: number }> =>
  (await axiosInt.get(`${NOTIFICATIONS_URL}/unread-count`)).data;

const useFetchUnreadCount = () => {
  const orgId = useNotificationOrgId();

  const {
    data: unreadCount,
    isLoading: isLoadingUnreadCount,
    error: errorFetchingUnreadCount,
  } = useQuery<{ count: number }>({
    queryKey: [NOTIFICATIONS_KEY, orgId, 'unread'],
    queryFn: fetchUnreadCountApi,
    enabled: Boolean(orgId),
    refetchInterval: UNREAD_COUNT_POLLING_MS,
  });

  return {
    unreadCount: unreadCount?.count,
    isLoadingUnreadCount,
    errorFetchingUnreadCount,
  };
};

export default useFetchUnreadCount;
